import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import classnames from 'classnames'
// Member Widgets//
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import MemberSummary from '../widgets/Member/MemberSummary'
import BenefitSummary from '../widgets/Member/BenefitSummary'
import HealthCareSpendingAccount from '../widgets/Member/HealthCareSpendingAccount'
import Pension from '../widgets/Member/Pension'
import Dependents from '../widgets/Member/Dependents'
import Loading from '../widgets/Loading'
import TabStyles from '../styles/tabs'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core/styles'

class Member extends Component {
  constructor (props) {
    super(props)
    this.updateTab = this.updateTab.bind(this)
    this.showContent = this.showContent.bind(this)

    this.state = {
      showContent: false,
      currentTab: 'MemberSummary'
    }
  }

  updateTab (e, v) {
    this.setState({ currentTab: v })

    this.props.push(`/Member/${v}`)
  }
  showContent (showConent) {
    this.setState({
      showContent: true
    })
  }

  render () {
    const {
      tab: currentTab = 'MemberSummary',
      classes = {}
    } = this.props

    let ret = null
    const history = this.props.isHistory
    const bs = currentTab === 'Benefits' && (history !== 'Benefits' && history !== 'History') ? 'benefitSearchMargin' : null
    const isBenefitsAvailable = this.props.memberSummary && this.props.memberSummary.isBenefitsAvailable

    // compose what needs to be returned
    if (!this.props.memberSummary) {
      ret = (
        <div className='pageContent'>
          <Header />
          <Loading message={localize('common.loadingContent')} />
        </div>
      )
    } else {
      ret = (
        <div className={`pageContent ${bs}`}>
          <Header />
          <section className='mainContent' id='mainContent'>
            <Grid fluid>
              <Row>
                <Col xs={12} lgOffset={1} lg={10}>
                  <div className='memberContainer'>
                    <h1 className='memberName'>{this.props.memberSummary.firstName} {this.props.memberSummary.lastName} </h1>
                  </div>
                  <Tabs value={currentTab} onChange={this.updateTab} indicatorColor={'secondary'}>
                    <Tab className={classnames(classes.ResponsiveTab, currentTab === 'MemberSummary' ? classes.AltSummaryTab : classes.SummaryTab)} label={localize('pages.Member.tab1')} value='MemberSummary' ref={(tab) => { this.memberSum = tab }} />
                    {isBenefitsAvailable && <Tab className={classnames(classes.ResponsiveTab, currentTab === 'Benefits' ? classes.AltSummaryTab : classes.SummaryTab)} label={localize('pages.Member.tab2')} value='Benefits' ref={(tab) => { this.benefits = tab }} />}
                    {this.props.memberSummary.isHCSAAvailable && <Tab className={classnames(classes.ResponsiveTab, currentTab === 'Hcsa' ? classes.AltSummaryTab : classes.SummaryTab)} label={localize('pages.Member.tab3')} value='Hcsa' ref={(tab) => { this.hcsa = tab }} />}
                    {this.props.memberSummary.isPensionAvailable && <Tab className={classnames(classes.ResponsiveTab, currentTab === 'Pension' ? classes.AltSummaryTab : classes.SummaryTab)} label={localize('pages.Member.pension')} value='Pension' ref={(tab) => { this.pension = tab }} />}
                  </Tabs>
                  <div className={classes.TabBar}>
                    {currentTab === 'MemberSummary' && <MemberSummary memberSummary={this.props.memberSummary} />}
                    {currentTab === 'MemberSummary' && (this.props.memberSummary.dependents && this.props.memberSummary.dependents.length > 0) ? <br /> : null}
                    {currentTab === 'MemberSummary' && (this.props.memberSummary.dependents && this.props.memberSummary.dependents.length > 0) ? <Dependents dependentsSummary={this.props.memberSummary.dependents} /> : null}
                    {currentTab === 'Benefits' && <BenefitSummary dependentId={this.props.lowerTab} typeId={this.props.typeId} type={this.props.type} isHistory={this.props.isHistory} />}
                    {currentTab === 'Hcsa' && <HealthCareSpendingAccount />}
                    {currentTab === 'Pension' && <Pension />}
                  </div>
                </Col>
              </Row>
            </Grid>
            <Footer />
          </section>
        </div>
      )
    }

    return ret
  }
}
function mapStateToProps (state, ownProps) {
  let parts = ownProps.location.pathname.split('/')
  return {
    memberSummary: state.memberSummaryReducer.memberSummary,
    tab: ownProps.match.params.tab,
    lowerTab: ownProps.match.params.lowerTab,
    typeId: ownProps.match.params.typeId,
    type: ownProps.match.params.type,
    isHistory: parts.pop() || parts.pop()
  }
}

const ConnectedMember = connect(mapStateToProps, { push })(injectIntl(Member))

const styles = {
  ...TabStyles
}

export default withStyles(styles)(ConnectedMember)



// WEBPACK FOOTER //
// ./src/components/Member.js